import { DataTable } from "@/components/molecules/tables/data-table";
import { useClientMembers } from "@/features/clients/hooks/use-clients";
import { useTranslation } from "@/features/utils/i18n";
import { useParams } from "react-router-dom";
import { PageLayout } from "../layout";
import {
  useCanSelectMember,
  useMembersBulkActions,
} from "./components/bulk-actions";
import { useMembersColumns } from "./components/columns";
import { CreateMemberDialog } from "./components/create-member-dialog";

/**
 * The team: who the agent knows about — the names it says, the people it books
 * and hands calls to. Most of them never sign in, and adding one takes a name.
 *
 * Who *can* sign in is a different page, under Paramètres (`../users`).
 * They used to be one screen and one table, which is how a salon's team came to
 * be a list of logins.
 */
export function MembersPage() {
  const { t } = useTranslation("members");
  const { company: clientId } = useParams<{ company: string }>();
  const { data: members = [], isLoading } = useClientMembers(clientId || "");

  const columns = useMembersColumns();
  const bulkActions = useMembersBulkActions();
  const canSelectMember = useCanSelectMember();

  return (
    <PageLayout
      title={t("title")}
      description={t("description")}
      actions={<CreateMemberDialog />}
    >
      <DataTable
        columns={columns}
        data={members}
        isLoading={isLoading}
        hideSearch={true}
        bulkActions={bulkActions}
        canSelectRow={canSelectMember}
        getRowId={(member) => member.membership.id}
      />
    </PageLayout>
  );
}
